<template>
  <v-expansion-panel :readonly="!settingsCount">
    <v-expansion-panel-header class="caption">
      <v-row no-gutters>
        <v-col cols="3">
          <v-icon small color="teal">mdi-database</v-icon>
          {{name}}
        </v-col>
        <v-col cols="8">
          <v-chip-group column>
            <div v-for="chip in chipsData" :key="chip.id" class="caption">
              <v-chip small :color="chip.color">
                <v-avatar left>
                  <v-icon small>{{chip.icon}}</v-icon>
                </v-avatar>
                <div>
                  <span v-if="chip.key" class="grey--text">{{chip.key}}</span>
                  <span v-if="chip.value&&chip.key">: </span>
                  <span v-if="chip.value" class="font-weight-bold">{{chip.value}}</span>
                </div>
              </v-chip>
            </div>
          </v-chip-group>
        </v-col>

        <v-col cols="1" class="grey--text caption">
          <v-tooltip bottom color="secondary">
            <template v-slot:activator="{ on }">
              <v-chip-group column>
                <v-chip color="teal caption" v-on="on" small>
                  <v-avatar left>
                    <v-icon small>mdi-database-search</v-icon>
                  </v-avatar>
                  <span class="font-weight-bold">{{settingsCount}}</span>
                </v-chip>
              </v-chip-group>
            </template>
            <Code v-if="settings" v-bind:code="settings" />
          </v-tooltip>
        </v-col>
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <Code v-bind:code="dataElement" />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import Code from "../Code";

export default {
  name: "DataElementMain",
  props: ["dataElement", "name"],
  components: { Code },
  data() {
    return {
      settings: {},
      settingsCount: 0,
      chipsData: []
    };
  },
  methods: {
    createChip: (function() {
      let i = 0;
      return function(icon, color, key, value) {
        return { icon, color, key, value, id: "f" + i++ };
      };
    })()
  },
  beforeMount() {
    let chipsData = [];
    let dataElement = this.$props.dataElement;
    let i = 0;

    let split = dataElement.modulePath.split("/");
    let ext = split[0];
    let action = split[split.length - 1].replace(".js", "");
    chipsData.push({
      icon: "mdi-puzzle",
      color: "light-green",
      value: `${ext} > ${action}`,
      id: i++
    });

    let settings = this.$props.dataElement.settings;

    for (let key in dataElement) {
      let value = dataElement[key];
      switch (key) {
        case "modulePath":
          break;
        case "settings":
          for (let setKey in value) {
            let v = value[setKey];
            if (
              typeof v === "string" ||
              typeof v === "number" ||
              typeof v === "boolean"
            ) {
              let vstring = v.toString();
              if (vstring.length > 0 && vstring.length <= 80) {
                // we have to limit this!
                chipsData.push(
                  this.createChip("mdi-database-search", "", setKey, vstring)
                );
              }
            }
          }

          if (typeof settings.source === "function") {
            settings.source = `[[[VIEWERBEGIN]]]${settings.source.toString()}[[[VIEWEREND]]]`;
          }

          break;
        default:
          chipsData.push({
            icon: "mdi-database-edit",
            color: "",
            key: key,
            value,
            id: i++
          });
      }
    }

    this.settings = settings;
    this.chipsData = chipsData;
    this.settingsCount = Object.keys(this.settings).length;
  }
};
</script>